'use client'
import { clsx } from 'clsx'

import { FC, useState } from 'react'

import { Block, Maybe } from '@/app/graphql/generated'
import { AnimationShowBlockComponent } from '@/app/shared/components/animation/show-block'
import { CourseItemComponent } from '@/app/shared/components/cours-item'
import { IId } from '@/app/shared/interfaces/common.interface'
import { clearData } from '@/app/shared/services/data-formatter'
import { ButtonComponent } from '@/app/shared/ui/button'
import { ContainerComponent } from '@/app/shared/ui/container'
import { TitleComponent } from '@/app/shared/ui/title'
import { t } from '@/core/lib/locale/i18n'

// interface
interface ICourses extends IId {
  data?: Maybe<Block>
}

// component
const CoursesComponent: FC<Readonly<ICourses>> = ({ data, id }) => {
  const buttons =
    data?.trainingCourse?.map((el) => ({
      id: el?.id,
      title: el?.text_button,
      is_intensive_course: el?.is_intensive_course,
    })) ?? []
  const [activeCourses, setActiveCourses] = useState(buttons[0])

  const currentCourse = data?.trainingCourse?.find((el) => el?.id === activeCourses.id)

  const basicData = clearData(JSON.parse(data?.contentAll ?? ''))

  return (
    <ContainerComponent className={'grid gap-[67px]'} id={id}>
      <div className={'grid gap-[30px] laptop:gap-16 desktop:gap-10'}>
        <TitleComponent>{t.training_courses()}</TitleComponent>
        <div className={'overflow-auto'}>
          <div className={'flex flex-wrap gap-2'}>
            {buttons?.map((el) => (
              <ButtonComponent
                key={el.id}
                color={el.is_intensive_course ? 'danger' : 'secondary'}
                variant={activeCourses.id !== el.id ? 'bordered' : undefined}
                onClick={() => setActiveCourses(el)}
                className={clsx('w-full flex-shrink-0 extraMobile:w-[calc(50%-5px)]', {
                  'pointer-events-none': activeCourses.id === el.id,
                })}
              >
                {el.title}
              </ButtonComponent>
            ))}
          </div>
        </div>
      </div>
      <AnimationShowBlockComponent
        initial={{
          opacity: 0,
          y: 30,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        viewport={{
          once: true,
          amount: 0,
        }}
      >
        <CourseItemComponent
          data={currentCourse}
          type={activeCourses.is_intensive_course ? 'intensive' : 'standard'}
          sticker={
            basicData?.sticker[
              data?.trainingCourse?.findIndex((el) => el?.id === activeCourses?.id) ?? 0
            ]?.image
          }
          buttonText={basicData?.button?.text}
        />
      </AnimationShowBlockComponent>
    </ContainerComponent>
  )
}

export default CoursesComponent
